<template>
    <footer class="p-2 text-center">
        <Link size="small" class="text-gray-700" :href="$app.sourceUrl">
            {{ $app.versionName }}
        </Link>
    </footer>
</template>
